let iframeElement: HTMLIFrameElement | null = null;

export default function downloadFileFromUrl(url: string) {
	if (iframeElement === null) {
		iframeElement = createIframeElement();
	}
	iframeElement.src = url;
}

function createIframeElement(): HTMLIFrameElement {
	const iframeElement = document.createElement('iframe');
	iframeElement.style.display = 'none';
	document.body.appendChild(iframeElement);
	return iframeElement;
}
